import type { Flag, ReviewedStepEnum } from '~/shared/api/data-ingestion-api/client'

export function hasActiveFlagOnStep(flags: Flag[], step: ReviewedStepEnum): boolean {
  return flags.some((flag) => flag.flag_status === 'pending' && flag.document_step === step)
}
